import type { SurfaceDescriptor, ActionDescriptor, FormSubmissionResult, FormSubmissionContext } from '@finance/contracts';
import { TableRenderer } from './TableRenderer.tsx';
import { FormRenderer } from './FormRenderer.tsx';

export interface SurfaceRendererProps {
  surface: SurfaceDescriptor;
  tables?: Record<string, Record<string, unknown>[]>;
  onAction?: (action: ActionDescriptor, context?: Record<string, unknown>) => void;
  onSubmit?: (commandId: string, values: Record<string, unknown>, context: FormSubmissionContext) => Promise<FormSubmissionResult>;
}

export function SurfaceRenderer({ surface, tables, onAction, onSubmit }: SurfaceRendererProps) {
  if ('columns' in surface) {
    return (
      <TableRenderer
        contract={surface}
        data={tables?.[surface.id] ?? []}
        onAction={(resolved, context) => resolved && onAction?.(resolved.action, context.row)}
      />
    );
  }

  if ('fields' in surface) {
    return <FormRenderer contract={surface} onSubmit={onSubmit} onAction={(action) => onAction?.(action)} />;
  }

  return null;
}
